module.exports = __webpack_public_path__ + "static/cosmo-logo-3843d71b800f832c1db0f5eca0680ea1.jpg";